<template>
    <!-- 官网首页,登陆页第二个头部 -->
    <div class="indexLoginBottomHead">
        <div class="bottom-head">
            <div class="contain">
                <el-row style="line-height:61px">
                    <el-col :span="7">
                        <div class="head-logo" style="width: 257px">
                            <img src="../../assets/img/logo7.png" alt style="width: 100%" />
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            <el-menu
                                @select="handleSelect"
                                mode="horizontal"
                                :router="true"
                                :default-active="$route.path"
                            >
                                <template v-for="(item, i) in routers">
                                    <el-menu-item
                                        v-if="item.index == 1"
                                        :key="i"
                                        :index="item.path"
                                    >{{ item.name }}</el-menu-item>
                                </template>
                                <template>
                                    <el-menu-item
                                        :index="'ShopIndex'"
                                        :route="'/ShopIndex'"
                                    >{{ '药城首页' }}</el-menu-item>
                                </template>
                            </el-menu>
                        </div>
                    </el-col>
                    <el-col :span="5" class="text-right">
                        <el-input
                            placeholder="请输入关键词搜索"
                            v-model="seachInput"
                            class="input-with-select head-input search-input-red-border"
                            style="width:236px"
                        >
                            <template slot="append">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    id="searchButton"
                                    @click="search()"
                                >搜索</el-button>
                            </template>
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "indexLoginBottomHead",
    data() {
        return {
            routers: []
        };
    },
    watch:{
        $route:{
            handler(){
                console.log(this.$route);
                if(this.$route.path == '/index'){
                    this.searchInput = "";
                }
            }
        }
    },
    methods: {
        handleSelect(index) {
            this.activeIndex = index;
            if (index == "/index") {
                this.seachInput = "";
            }
        },
        //全局搜索
        search() {
            let that = this;
            if (!that.seachInput) {
                that.$message({
                    type: "warning",
                    message: "请输入搜索内容"
                });
            } else {
                that.$router.push({
                    path: "/searchList",
                    query: { content: that.seachInput }
                });
            }
        }
    },
    created() {
        this.routers = this.$router.options.routes[0].children;
    },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottom-head .is-active {
    color: black;
    border-bottom: 2px solid #f64420;
    border-bottom-color: #f64420;
    background-color: none;
}
.bottom-head .el-menu-item {
    color: #777f8f !important;
}

.head-title {
    font-size: 12px;
    line-height: 40px;
    letter-spacing: 1.9px;
    color: #ffffff;
    opacity: 0.4;
}
.top-head {
    width: 100%;
    height: 40px;
    background-color: #333333;
}
.top-head .el-col,
.top-head .el-row {
    height: 100%;
}
.el-menu-black > .el-menu-item {
    line-height: 40px;
    height: 40px;
    opacity: 0.4;
    font-size: 12px;
}
.el-menu-black {
    line-height: 40px;
    height: 40px;
    float: right;
}
.el-menu-white {
    width: 650px;
    border: none;
    float: right;
}
.bottom-head {
    padding: 20px 0px;
    /* box-shadow: 0px 0px 8px 0px
		rgba(0, 0, 0, 0.12); */
}
.head-logo {
    max-height: 60px;
}
.head-logo img {
    display: block;
    height: 60px;
}
/* header .el-input-group {
  width: 252px;
  margin-top: 15px;
  float: right;
} */
.el-menu.el-menu--horizontal {
    border-bottom: none;
}
</style>
<style>
.search-input-red-border .el-input__inner {
    border: solid 1px #f64420;
}
</style>



// WEBPACK FOOTER //
// src/components/common/indexLoginBottomHead.vue